<table>
    <th class="detail-name col-3">
        Words*
    </th>
    <td class="col-8">
        <tr *ngFor="let encounter of encounters;let isLast=last">
            <td>{{ getDescription(encounter) }}</td>
            <app-speech-rec-artifact [artifactId]="encounter.ID" [studentId]="studentId"></app-speech-rec-artifact>
        </tr>
    </td>
</table>